import React from 'react'

function IconCheckmark() {
  return <svg role="presentation" aria-hidden="true" className="icon icon--checkmark">
    <use xlinkHref="#icon-checkmark" />
  </svg>
}

export default IconCheckmark
